import React from "react";
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { Spinner } from "../Utils/Loaders";

export const MedicalServiceInfo = ({ medicalService, isLoading, inline = false }) => {
    const { t } = useTranslation();

    if (isLoading)
        return <Spinner />

    if (!medicalService || !medicalService.service)
        return null;

    if (inline) {
        const items = [
            `${t("calendar.medicalServiceInfo.medicalService")}: ${medicalService.service?.serviceNameReference}`,
            `${t("calendar.medicalServiceInfo.coversMedicalInsurance")}: ${medicalService.isCoveredByMedicalInsurance ? t("commons.yes") : t("commons.no")}`,
        ];
        if (medicalService.isCoveredByMedicalInsurance && medicalService.coverRequirements) {
            items.push(`${t("calendar.medicalServiceInfo.approvalRequired")}: ${medicalService.coverRequirements?.requiresApproval ? t("commons.yes") : t("commons.no")}`);
        }
        if (medicalService.coverRequirements && medicalService.coverRequirements.requiredCopago) {
            items.push(`${t("calendar.medicalServiceInfo.copayRequired")}: ${medicalService.coverRequirements?.copagoComments}`);
        }
        if (!medicalService.isCoveredByMedicalInsurance && medicalService.price) {
            items.push(`${t("calendar.medicalServiceInfo.price")}: ${medicalService.service?.serviceNameReference}`);
        }
        return (
            <Row>
                <Col sm={12}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center', padding: '6px 0', fontSize: '13px' }}>
                        {items.map((item, idx) => (
                            <React.Fragment key={idx}>
                                {idx > 0 && <span style={{ color: '#aaa', margin: '0 4px' }}>|</span>}
                                <span className="card-text">{item}</span>
                            </React.Fragment>
                        ))}
                    </div>
                </Col>
            </Row>
        );
    }

    return (
        <Row>
            <Col sm={12}>
                <div className="info">
                    <div><span className="card-label">{t("calendar.medicalServiceInfo.medicalService")}:</span> <span className="card-text">{medicalService.service?.serviceNameReference}</span></div>
                    <div><span className="card-label">{t("calendar.medicalServiceInfo.coversMedicalInsurance")}:</span> <span className="card-text">{medicalService.isCoveredByMedicalInsurance ? t("commons.yes") : t("commons.no")}</span></div>
                    {
                        medicalService.isCoveredByMedicalInsurance && medicalService.coverRequirements &&
                        <div><span className="card-label">{t("calendar.medicalServiceInfo.approvalRequired")}:</span> <span className="card-text">{medicalService.coverRequirements?.requiresApproval ? t("commons.yes") : t("commons.no")}</span></div>
                    }
                    {
                        medicalService.coverRequirements && medicalService.coverRequirements.requiredCopago &&
                        <div><span className="card-label">{t("calendar.medicalServiceInfo.copayRequired")}:</span> <span className="card-text">{medicalService.coverRequirements?.copagoComments}</span></div>
                    }
                    {
                        !medicalService.isCoveredByMedicalInsurance && medicalService.price &&
                        <>
                            <div><span className="card-label">{t("calendar.medicalServiceInfo.price")}:</span> <span className="card-text">{medicalService.service?.serviceNameReference}</span></div>
                            <div>
                                <span className="card-label">{t("calendar.medicalServiceInfo.priceNotes")}</span>
                            </div>
                        </>
                    }
                </div>
            </Col>
        </Row>
    );
}